import Button from '@space-core/components/button'
import styled from 'styled-components'

export const CustomImage = styled.img`
  max-height: 3rem;
  max-width: 3rem;
`
CustomImage.displayName = 'CustomImage'

export const CustomButton = styled(Button)<{ $hasCommunityAssociated: boolean }>`
  color: ${(props) =>
    props.$hasCommunityAssociated ? `var(--red-dark)` : `var(--blue-dark)`}!important;
`

CustomButton.displayName = 'CustomButton'

export const CourseName = styled.p`
  font-size: 1.125rem;
`

CourseName.displayName = 'CourseName'
